'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('@onekeyfe/hd-transport');
var hdShared = require('@onekeyfe/hd-shared');
var ByteBuffer = require('bytebuffer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var transport__default = /*#__PURE__*/_interopDefaultLegacy(transport);
var ByteBuffer__default = /*#__PURE__*/_interopDefaultLegacy(ByteBuffer);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const { parseConfigure: parseConfigure$1, check: check$1, ProtocolV1: ProtocolV1$1 } = transport__default["default"];
const CONFIGURATION_ID = 1;
const INTERFACE_ID = 0;
const ENDPOINT_ID = 1;
const PACKET_SIZE = transport.PROTOCOL_V1_USB_PACKET_SIZE;
const PAYLOAD_SIZE = transport.PROTOCOL_V1_CHUNK_PAYLOAD_SIZE;
const REPORT_ID = transport.PROTOCOL_V1_REPORT_ID;
const HEADER_LENGTH = transport.PROTOCOL_V1_MESSAGE_HEADER_SIZE;
const PACKET_IO_MAX_RETRIES = 3;
const PACKET_IO_RETRY_DELAY = 300;
const PROTOCOL_V1_PROBE_TIMEOUT = 5000;
const PROTOCOL_V2_PROBE_TIMEOUT = 1000;
const EXPECTED_PROTOCOL_V2_PROBE_ATTEMPTS = 2;
let activeWebUsbTransport;
let usbDisconnectListenerAttached = false;
function registerActiveWebUsbTransport(instance, usb) {
    activeWebUsbTransport = instance;
    if (usbDisconnectListenerAttached)
        return;
    usbDisconnectListenerAttached = true;
    usb.addEventListener('disconnect', event => {
        if (!event.device)
            return;
        const path = hdShared.resolveOneKeyUsbDevicePath(event.device);
        if (!path)
            return;
        activeWebUsbTransport === null || activeWebUsbTransport === void 0 ? void 0 : activeWebUsbTransport.markProtocolStale(path);
        activeWebUsbTransport === null || activeWebUsbTransport === void 0 ? void 0 : activeWebUsbTransport.emitDeviceDisconnect(path, event.device);
    });
}
class WebUsbTransport extends transport.ProtocolV2UsbTransportBase {
    constructor() {
        super({
            router: transport.PROTOCOL_V2_CHANNEL_USB,
            maxFrameBytes: transport.PROTOCOL_V2_FRAME_MAX_BYTES,
            logPrefix: 'ProtocolV2 WebUSB',
        });
        this.deviceProtocol = new Map();
        this.confirmedDeviceProtocols = new Map();
        this.deviceProtocolHints = new Map();
        this.staleProtocolPaths = new Set();
        this.acquiredPaths = new Set();
        this.probedDeviceObjects = new Map();
        this.deviceEndpoints = new Map();
        this.name = 'WebUsbTransport';
        this.stopped = false;
        this.configured = false;
        this.deviceList = [];
        this.configurationId = CONFIGURATION_ID;
        this.endpointId = ENDPOINT_ID;
        this.interfaceId = INTERFACE_ID;
    }
    init(logger, emitter) {
        this.Log = logger;
        this.emitter = emitter;
        const { usb } = navigator;
        if (!usb) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, 'WebUSB is not supported by current browsers');
        }
        this.usb = usb;
        registerActiveWebUsbTransport(this, usb);
    }
    emitDeviceDisconnect(path, device) {
        var _a, _b;
        (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.emit(transport.TRANSPORT_EVENT.DEVICE_DISCONNECT, {
            name: (_b = device === null || device === void 0 ? void 0 : device.productName) !== null && _b !== void 0 ? _b : '',
            id: path,
            connectId: path,
        });
    }
    markProtocolStale(path) {
        this.staleProtocolPaths.add(path);
        this.probedDeviceObjects.delete(path);
    }
    configure(signedData) {
        const messages = parseConfigure$1(signedData);
        this.configured = true;
        this.messages = messages;
    }
    configureProtocolV2(signedData) {
        var _a;
        const schemaSource = typeof signedData === 'string'
            ? signedData
            : (_a = JSON.stringify(signedData)) !== null && _a !== void 0 ? _a : String(signedData);
        if (schemaSource === this.protocolV2SchemaSource)
            return;
        const hadProtocolV2Schema = this.protocolV2SchemaSource !== undefined;
        this.messagesV2 = parseConfigure$1(signedData);
        this.protocolV2SchemaSource = schemaSource;
        if (!hadProtocolV2Schema)
            return;
        this.invalidateAllProtocolV2UsbLinks('Protocol V2 schema reconfigured').catch(error => { var _a; return (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[WebUsbTransport] schema link cleanup failed:', error); });
    }
    promptDeviceAccess() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.usb)
                return null;
            try {
                const device = yield this.usb.requestDevice({ filters: hdShared.ONEKEY_WEBUSB_FILTER });
                return device;
            }
            catch (e) {
                this.Log.debug('requestDevice error: ', e instanceof Error ? `${e.name}: ${e.message}` : String(e));
                return null;
            }
        });
    }
    enumerate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getConnectedDevices();
            return this.deviceList;
        });
    }
    getConnectedDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.usb)
                return [];
            const devices = yield this.usb.getDevices();
            const onekeyDevices = devices.filter(dev => {
                const isOneKey = hdShared.ONEKEY_WEBUSB_FILTER.some((desc) => dev.vendorId === desc.vendorId && dev.productId === desc.productId);
                return isOneKey && !hdShared.isKnownTrezorWebUsbDevice(dev);
            });
            this.deviceList = onekeyDevices.flatMap(device => {
                const path = hdShared.resolveOneKeyUsbDevicePath(device);
                if (!path)
                    return [];
                const protocolHint = hdShared.inferProtocolHintFromUsbId(device.vendorId, device.productId);
                if (protocolHint) {
                    this.deviceProtocolHints.set(path, protocolHint);
                }
                return [
                    {
                        path,
                        device,
                        commType: 'webusb',
                    },
                ];
            });
            return this.deviceList;
        });
    }
    acquire(input) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            if (!input.path)
                return;
            try {
                yield this.rotateProtocolV2UsbGeneration(input.path, 'WebUSB transport acquired');
                yield this.closeOpenDevice(input.path);
                yield this.connect((_a = input.path) !== null && _a !== void 0 ? _a : '', true);
                if (input.skipProtocolProbe) {
                    if (!input.expectedProtocol) {
                        throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, 'skipProtocolProbe requires an expected protocol');
                    }
                    if (this.confirmedDeviceProtocols.get(input.path) !== input.expectedProtocol) {
                        throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, 'skipProtocolProbe requires a previously confirmed protocol for this WebUSB endpoint');
                    }
                    this.staleProtocolPaths.delete(input.path);
                    this.deviceProtocol.set(input.path, input.expectedProtocol);
                    const currentDevice = (_b = this.deviceList.find(d => d.path === input.path)) === null || _b === void 0 ? void 0 : _b.device;
                    if (currentDevice) {
                        this.probedDeviceObjects.set(input.path, currentDevice);
                    }
                }
                else if (input.forceProtocolDetection) {
                    this.staleProtocolPaths.delete(input.path);
                    this.deviceProtocol.delete(input.path);
                    this.deviceProtocolHints.delete(input.path);
                }
                if (!input.skipProtocolProbe && this.staleProtocolPaths.has(input.path)) {
                    this.staleProtocolPaths.delete(input.path);
                    this.deviceProtocol.delete(input.path);
                }
                if (!input.skipProtocolProbe && this.deviceProtocol.has(input.path)) {
                    const currentDevice = (_c = this.deviceList.find(d => d.path === input.path)) === null || _c === void 0 ? void 0 : _c.device;
                    if (!currentDevice || currentDevice !== this.probedDeviceObjects.get(input.path)) {
                        this.deviceProtocol.delete(input.path);
                    }
                }
                const cachedProtocol = this.deviceProtocol.get(input.path);
                if (!input.skipProtocolProbe &&
                    cachedProtocol &&
                    input.expectedProtocol &&
                    cachedProtocol !== input.expectedProtocol) {
                    this.deviceProtocol.delete(input.path);
                }
                if (!this.deviceProtocol.has(input.path)) {
                    const usbDevice = (_d = this.deviceList.find(device => device.path === input.path)) === null || _d === void 0 ? void 0 : _d.device;
                    const protocolHint = input.expectedProtocol
                        ? undefined
                        : (_f = (_e = input.protocolHint) !== null && _e !== void 0 ? _e : this.deviceProtocolHints.get(input.path)) !== null && _f !== void 0 ? _f : hdShared.inferProtocolHintFromUsbId(usbDevice === null || usbDevice === void 0 ? void 0 : usbDevice.vendorId, usbDevice === null || usbDevice === void 0 ? void 0 : usbDevice.productId);
                    if (protocolHint) {
                        this.deviceProtocolHints.set(input.path, protocolHint);
                    }
                    const detectedProtocol = yield this.detectProtocol(input.path, input.expectedProtocol, protocolHint);
                    this.confirmedDeviceProtocols.set(input.path, detectedProtocol);
                    const probedDevice = (_g = this.deviceList.find(d => d.path === input.path)) === null || _g === void 0 ? void 0 : _g.device;
                    if (probedDevice) {
                        this.probedDeviceObjects.set(input.path, probedDevice);
                    }
                }
                this.acquiredPaths.add(input.path);
                return yield Promise.resolve(input.path);
            }
            catch (e) {
                this.Log.debug('acquire error: ', e instanceof Error ? `${e.name}: ${e.message}` : String(e));
                this.acquiredPaths.delete(input.path);
                yield this.closeOpenDevice(input.path);
                throw e;
            }
        });
    }
    createProtocolMismatchError(expected) {
        return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, `Device protocol mismatch: expected ${expected}, but device did not respond to expected protocol`);
    }
    createProtocolProbeTimeoutError(expected, attempts) {
        return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceInitializeFailed, `Protocol ${expected} probe timeout after ${attempts} attempts`);
    }
    createProtocolDetectionError() {
        return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound);
    }
    detectProtocol(path, expectedProtocol, protocolHint) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (expectedProtocol === 'V1') {
                if (yield this.probeProtocolV1(path)) {
                    this.deviceProtocol.set(path, 'V1');
                    return 'V1';
                }
                yield this.closeConnectionAfterProbe(path);
                throw this.createProtocolMismatchError(expectedProtocol);
            }
            if (expectedProtocol === 'V2') {
                for (let attempt = 1; attempt <= EXPECTED_PROTOCOL_V2_PROBE_ATTEMPTS; attempt += 1) {
                    if (yield this.probeProtocolV2(path)) {
                        this.deviceProtocol.set(path, 'V2');
                        return 'V2';
                    }
                    if (attempt < EXPECTED_PROTOCOL_V2_PROBE_ATTEMPTS) {
                        yield this.resetConnectionAfterProbe(path);
                        (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[WebUsbTransport] Protocol V2 probe timed out, retrying ${attempt + 1}/${EXPECTED_PROTOCOL_V2_PROBE_ATTEMPTS}`);
                    }
                    else {
                        yield this.closeConnectionAfterProbe(path);
                    }
                }
                this.deviceProtocol.delete(path);
                throw this.createProtocolProbeTimeoutError(expectedProtocol, EXPECTED_PROTOCOL_V2_PROBE_ATTEMPTS);
            }
            const probeOrder = protocolHint === 'V2' || this.deviceProtocol.get(path) === 'V2' ? ['V2', 'V1'] : ['V1', 'V2'];
            for (const [index, protocol] of probeOrder.entries()) {
                const detected = protocol === 'V1' ? yield this.probeProtocolV1(path) : yield this.probeProtocolV2(path);
                if (detected) {
                    this.deviceProtocol.set(path, protocol);
                    return protocol;
                }
                if (index < probeOrder.length - 1) {
                    yield this.resetConnectionAfterProbe(path);
                }
                else {
                    yield this.closeConnectionAfterProbe(path);
                }
            }
            this.deviceProtocol.delete(path);
            throw this.createProtocolDetectionError();
        });
    }
    findDevice(path) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.deviceList.length === 0) {
                yield this.getConnectedDevices();
            }
            let device = this.deviceList.find(d => d.path === path);
            if (device == null) {
                yield this.getConnectedDevices();
                device = this.deviceList.find(d => d.path === path);
                if (device == null) {
                    throw new Error('Action was interrupted.');
                }
            }
            return device.device;
        });
    }
    connect(path, first) {
        return __awaiter(this, void 0, void 0, function* () {
            const maxRetries = 5;
            for (let i = 0; i < maxRetries; i++) {
                try {
                    return yield this.connectToDevice(path, first);
                }
                catch (e) {
                    if (i === maxRetries - 1) {
                        throw e;
                    }
                    yield hdShared.wait(i * 200);
                }
            }
        });
    }
    discoverEndpoints(device) {
        var _a, _b;
        for (const config of device.configurations) {
            for (const iface of config.interfaces) {
                for (const alt of iface.alternates) {
                    if (alt.interfaceClass === 0xff) {
                        let endpointIn = this.endpointId;
                        let endpointOut = this.endpointId;
                        for (const ep of alt.endpoints) {
                            if (ep.direction === 'in')
                                endpointIn = ep.endpointNumber;
                            else
                                endpointOut = ep.endpointNumber;
                        }
                        (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[WebUsbTransport] discovered vendor interface ${iface.interfaceNumber}, ` +
                            `endpointIn=${endpointIn}, endpointOut=${endpointOut}`);
                        return { interfaceNumber: iface.interfaceNumber, endpointIn, endpointOut };
                    }
                }
            }
        }
        (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug('[WebUsbTransport] no vendor interface found, using defaults');
        return {
            interfaceNumber: this.interfaceId,
            endpointIn: this.endpointId,
            endpointOut: this.endpointId,
        };
    }
    connectToDevice(path, first) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let device = yield this.findDevice(path);
            if (!device.opened) {
                yield device.open();
            }
            if (first || this.deviceProtocol.get(path) !== 'V1') {
                try {
                    yield device.reset();
                }
                catch (error) {
                    (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[WebUsbTransport] reset before claim failed, continuing:', error);
                }
            }
            yield this.getConnectedDevices();
            device = yield this.findDevice(path);
            if (!device.opened) {
                yield device.open();
            }
            if (first ||
                !device.configuration ||
                device.configuration.configurationValue !== this.configurationId) {
                yield device.selectConfiguration(this.configurationId);
            }
            const endpoints = this.discoverEndpoints(device);
            this.deviceEndpoints.set(path, endpoints);
            yield device.claimInterface(endpoints.interfaceNumber);
            yield this.clearEndpointHalt(device, 'in', endpoints.endpointIn);
            yield this.clearEndpointHalt(device, 'out', endpoints.endpointOut);
        });
    }
    closeOpenDevice(path) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const current = (_a = this.deviceList.find(device => device.path === path)) === null || _a === void 0 ? void 0 : _a.device;
            if (!(current === null || current === void 0 ? void 0 : current.opened))
                return;
            const endpoints = this.deviceEndpoints.get(path);
            const ifaceNum = (_b = endpoints === null || endpoints === void 0 ? void 0 : endpoints.interfaceNumber) !== null && _b !== void 0 ? _b : this.interfaceId;
            try {
                yield current.releaseInterface(ifaceNum);
            }
            catch (error) {
                (_c = this.Log) === null || _c === void 0 ? void 0 : _c.debug('[WebUsbTransport] releaseInterface before reconnect failed:', error);
            }
            try {
                yield current.close();
            }
            catch (error) {
                (_d = this.Log) === null || _d === void 0 ? void 0 : _d.debug('[WebUsbTransport] close before reconnect failed:', error);
            }
        });
    }
    clearEndpointHalt(device, direction, endpointNumber) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield device.clearHalt(direction, endpointNumber);
            }
            catch (error) {
                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[WebUsbTransport] clearHalt ${direction} endpoint ${endpointNumber} failed, continuing:`, error);
            }
        });
    }
    assertAcquired(path) {
        if (!this.acquiredPaths.has(path)) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, `Device is not acquired for ${path}`);
        }
    }
    post(session, name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.assertAcquired(session);
            if (this.deviceProtocol.get(session) === 'V2') {
                yield this.sendProtocolV2UsbFlowControl(session, name, data);
                return;
            }
            yield this.call(session, name, data);
        });
    }
    getErrorMessage(error) {
        if (!error)
            return '';
        if (typeof error === 'string')
            return error;
        if (typeof error === 'object' && 'message' in error) {
            const { message } = error;
            return typeof message === 'string' ? message : String(message !== null && message !== void 0 ? message : '');
        }
        return String(error);
    }
    isRetryablePacketIoError(error) {
        const message = this.getErrorMessage(error).toLowerCase();
        return (message.includes('transferout') ||
            message.includes('transferin') ||
            message.includes('usbdevice') ||
            message.includes('disconnected') ||
            message.includes('device not found') ||
            message.includes('action was interrupted') ||
            message.includes('networkerror'));
    }
    reconnectForPacketIoRetry(path, direction, attempt, error) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.Log.debug(`[WebUsbTransport] transfer${direction} failed, retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(error)}`);
            this.staleProtocolPaths.add(path);
            yield hdShared.wait(attempt * PACKET_IO_RETRY_DELAY);
            try {
                const currentDevice = yield this.findDevice(path);
                if (currentDevice.opened) {
                    const endpoints = this.deviceEndpoints.get(path);
                    const ifaceNum = (_a = endpoints === null || endpoints === void 0 ? void 0 : endpoints.interfaceNumber) !== null && _a !== void 0 ? _a : this.interfaceId;
                    try {
                        yield currentDevice.releaseInterface(ifaceNum);
                    }
                    catch (releaseError) {
                        this.Log.debug('[WebUsbTransport] releaseInterface before retry error:', releaseError);
                    }
                    yield currentDevice.close();
                }
            }
            catch (closeError) {
                this.Log.debug('[WebUsbTransport] close device before retry error:', closeError);
            }
            yield this.getConnectedDevices();
            yield this.connect(path, false);
        });
    }
    getTransferInData(result) {
        if (result.status !== 'ok') {
            throw new Error(`transferIn status: ${String(result.status)}`);
        }
        if (!result.data || result.data.byteLength === 0) {
            throw new Error('transferIn no data');
        }
        return result.data;
    }
    toArrayBuffer(buffer) {
        if (buffer instanceof ArrayBuffer) {
            return buffer;
        }
        const copied = new Uint8Array(buffer.byteLength);
        copied.set(new Uint8Array(buffer));
        return copied.buffer;
    }
    transferOutWithRetry(path, packet) {
        return __awaiter(this, void 0, void 0, function* () {
            let lastError;
            for (let attempt = 1; attempt <= PACKET_IO_MAX_RETRIES; attempt += 1) {
                try {
                    yield this.transferOutOnce(path, packet);
                    return;
                }
                catch (error) {
                    lastError = error;
                    const shouldRetry = attempt < PACKET_IO_MAX_RETRIES && this.isRetryablePacketIoError(error);
                    if (!shouldRetry) {
                        throw error;
                    }
                    try {
                        yield this.reconnectForPacketIoRetry(path, 'out', attempt, error);
                    }
                    catch (reconnectError) {
                        lastError = reconnectError;
                        this.Log.debug(`[WebUsbTransport] transferout reconnect failed on retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(reconnectError)}`);
                    }
                }
            }
            throw lastError;
        });
    }
    transferOutOnce(path, packet) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const device = yield this.findDevice(path);
            if (!device.opened) {
                yield this.connect(path, false);
            }
            const endpoints = this.deviceEndpoints.get(path);
            const endpointOut = (_a = endpoints === null || endpoints === void 0 ? void 0 : endpoints.endpointOut) !== null && _a !== void 0 ? _a : this.endpointId;
            const transferBuffer = this.toArrayBuffer(packet.buffer.slice(packet.byteOffset, packet.byteOffset + packet.byteLength));
            yield device.transferOut(endpointOut, transferBuffer);
        });
    }
    transferInWithRetry(path, length, cancelToken) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let lastError;
            for (let attempt = 1; attempt <= PACKET_IO_MAX_RETRIES; attempt += 1) {
                if (cancelToken === null || cancelToken === void 0 ? void 0 : cancelToken.cancelled) {
                    throw new Error('transferIn cancelled');
                }
                try {
                    const device = yield this.findDevice(path);
                    if (!device.opened) {
                        yield this.connect(path, false);
                    }
                    const endpoints = this.deviceEndpoints.get(path);
                    const endpointIn = (_a = endpoints === null || endpoints === void 0 ? void 0 : endpoints.endpointIn) !== null && _a !== void 0 ? _a : this.endpointId;
                    const result = yield device.transferIn(endpointIn, length);
                    return this.getTransferInData(result);
                }
                catch (error) {
                    lastError = error;
                    if (cancelToken === null || cancelToken === void 0 ? void 0 : cancelToken.cancelled) {
                        throw error;
                    }
                    const shouldRetry = attempt < PACKET_IO_MAX_RETRIES && this.isRetryablePacketIoError(error);
                    if (!shouldRetry) {
                        throw error;
                    }
                    try {
                        yield this.reconnectForPacketIoRetry(path, 'in', attempt, error);
                    }
                    catch (reconnectError) {
                        lastError = reconnectError;
                        this.Log.debug(`[WebUsbTransport] transferin reconnect failed on retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(reconnectError)}`);
                    }
                }
            }
            throw lastError;
        });
    }
    transferInOnce(path, length) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const device = yield this.findDevice(path);
            if (!device.opened) {
                throw new Error('USBDevice is not open for transferIn');
            }
            const endpoints = this.deviceEndpoints.get(path);
            const endpointIn = (_a = endpoints === null || endpoints === void 0 ? void 0 : endpoints.endpointIn) !== null && _a !== void 0 ? _a : this.endpointId;
            const result = yield device.transferIn(endpointIn, length);
            return this.getTransferInData(result);
        });
    }
    closeConnectionAfterProbe(path) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.rotateProtocolV2UsbGeneration(path, 'WebUSB protocol probe reset');
            yield this.closeOpenDevice(path);
        });
    }
    resetConnectionAfterProbe(path) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.closeConnectionAfterProbe(path);
            yield this.getConnectedDevices();
            yield this.connect(path, false);
        });
    }
    withProtocolReadTimeout(path, promise, timeoutMs, protocol, onTimeout) {
        return __awaiter(this, void 0, void 0, function* () {
            let timer;
            let timedOut = false;
            const waitForeverAfterTimeout = () => new Promise(() => { });
            const guardedPromise = promise.then(value => (timedOut ? waitForeverAfterTimeout() : value), error => {
                if (timedOut) {
                    return waitForeverAfterTimeout();
                }
                throw error;
            });
            try {
                return yield Promise.race([
                    guardedPromise,
                    new Promise((_, reject) => {
                        timer = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                            timedOut = true;
                            onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout();
                            if (protocol === 'V1') {
                                try {
                                    yield this.resetConnectionAfterProbe(path);
                                }
                                catch (error) {
                                    this.Log.debug('[WebUsbTransport] reset after Protocol V1 timeout failed:', error);
                                }
                            }
                            reject(new Error(`Protocol ${protocol} read timeout after ${timeoutMs}ms`));
                        }), timeoutMs);
                    }),
                ]);
            }
            finally {
                if (timer)
                    clearTimeout(timer);
            }
        });
    }
    probeProtocolV1(path) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.messages) {
                return false;
            }
            try {
                yield this.callProtocolV1(path, 'Initialize', {}, {
                    timeoutMs: PROTOCOL_V1_PROBE_TIMEOUT,
                });
                return true;
            }
            catch (_error) {
                return false;
            }
        });
    }
    probeProtocolV2(path) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.messages || !this.messagesV2) {
                return false;
            }
            return transport.probeProtocolV2({
                call: (name, data, options) => this.callProtocolV2(path, name, data, options),
                timeoutMs: PROTOCOL_V2_PROBE_TIMEOUT,
                logger: this.Log,
                logPrefix: 'ProtocolV2 WebUSB',
            });
        });
    }
    call(path, name, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.messages == null) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            this.assertAcquired(path);
            const device = yield this.findDevice(path);
            if (!device) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound);
            }
            const protocol = this.deviceProtocol.get(path);
            if (!protocol) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, `Device protocol has not been detected for ${path}`);
            }
            if (protocol === 'V2') {
                return this.callProtocolV2(path, name, data, options);
            }
            return this.callProtocolV1(path, name, data, options);
        });
    }
    callProtocolV1(path, name, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { messages } = this;
            if (!messages) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            const encodeBuffers = ProtocolV1$1.encodeMessageChunks(messages, name, data);
            for (const buffer of encodeBuffers) {
                const newArray = new Uint8Array(PACKET_SIZE);
                newArray[0] = REPORT_ID;
                newArray.set(new Uint8Array(buffer), 1);
                yield this.transferOutWithRetry(path, newArray);
            }
            const resData = yield this.receiveData(path, options === null || options === void 0 ? void 0 : options.timeoutMs);
            if (typeof resData !== 'string') {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.NetworkError, 'Returning data is not string.');
            }
            const jsonData = ProtocolV1$1.decodeMessage(messages, resData);
            return check$1.call(jsonData);
        });
    }
    callProtocolV2(path, name, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callProtocolV2Usb(path, name, data, options);
        });
    }
    receiveData(path, timeoutMs) {
        return __awaiter(this, void 0, void 0, function* () {
            const deadline = timeoutMs ? Date.now() + timeoutMs : undefined;
            const readPacket = () => __awaiter(this, void 0, void 0, function* () {
                const cancelToken = { cancelled: false };
                const transferIn = this.transferInWithRetry(path, PACKET_SIZE, cancelToken);
                return deadline
                    ? this.withProtocolReadTimeout(path, transferIn, Math.max(deadline - Date.now(), 1), 'V1', () => {
                        cancelToken.cancelled = true;
                    })
                    : transferIn;
            });
            const firstPacketData = yield readPacket();
            const firstData = this.toArrayBuffer(firstPacketData.buffer.slice(1));
            const { length, typeId, restBuffer } = ProtocolV1$1.decodeFirstChunk(firstData);
            const lengthWithHeader = Number(length + HEADER_LENGTH);
            const decoded = new ByteBuffer__default["default"](lengthWithHeader);
            decoded.writeUint16(typeId);
            decoded.writeUint32(length);
            if (length) {
                decoded.append(restBuffer);
            }
            while (decoded.offset < lengthWithHeader) {
                const packetData = yield readPacket();
                const buffer = this.toArrayBuffer(packetData.buffer.slice(1));
                if (lengthWithHeader - decoded.offset >= PAYLOAD_SIZE) {
                    decoded.append(buffer);
                }
                else {
                    decoded.append(buffer.slice(0, lengthWithHeader - decoded.offset));
                }
            }
            decoded.reset();
            const result = decoded.toBuffer();
            return Buffer.from(result).toString('hex');
        });
    }
    release(path) {
        return __awaiter(this, void 0, void 0, function* () {
            this.acquiredPaths.delete(path);
            yield this.invalidateProtocolV2UsbLink(path, 'WebUSB transport released');
            yield this.closeOpenDevice(path);
            this.deviceEndpoints.delete(path);
        });
    }
    getProtocolV2UsbSchemas() {
        if (!this.messages || !this.messagesV2) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
        }
        return {
            protocolV1: this.messages,
            protocolV2: this.messagesV2,
        };
    }
    getProtocolV2UsbLogger() {
        return this.Log;
    }
    writeProtocolV2UsbPacket(path, frame, _context) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.transferOutOnce(path, frame);
        });
    }
    readProtocolV2UsbPacket(path, _context) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataView = yield this.transferInOnce(path, transport.PROTOCOL_V2_FRAME_MAX_BYTES);
            return new Uint8Array(this.toArrayBuffer(dataView.buffer.slice(dataView.byteOffset, dataView.byteOffset + dataView.byteLength)));
        });
    }
    resetProtocolV2UsbNativeLink(path, _reason) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.closeOpenDevice(path);
        });
    }
    onProtocolV2UsbLinkInvalidated(path, reason) {
        var _a;
        this.deviceProtocol.delete(path);
        (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[WebUsbTransport] Protocol V2 link invalidated: ${path}`, reason);
    }
    createProtocolV2UsbTimeoutError(name, timeoutMs) {
        return new transport.ProtocolV2LinkError('response-timeout', `Protocol V2 response timeout after ${timeoutMs}ms for ${name}`);
    }
    getProtocolType(path) {
        return this.deviceProtocol.get(path);
    }
}

const BLE_ATT_HEADER_BYTES = 3;
function resolveBlePacketCapacity(mtu, maximumPacketCapacity, fallbackPacketCapacity) {
    if (typeof mtu !== 'number' || !Number.isFinite(mtu) || mtu <= BLE_ATT_HEADER_BYTES) {
        return fallbackPacketCapacity;
    }
    return Math.min(maximumPacketCapacity, Math.floor(mtu) - BLE_ATT_HEADER_BYTES);
}

const { parseConfigure, ProtocolV1, check } = transport__default["default"];
const toBleDescriptor = (device, protocolType) => (Object.assign({ id: device.id, name: device.name, path: device.id, debug: false, commType: 'electron-ble' }, (protocolType ? { protocolType } : {})));
const invokeNobleBle = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request;
    if (response &&
        typeof response === 'object' &&
        'type' in response &&
        response.type === 'NobleBleIpcError' &&
        'success' in response &&
        response.success === false &&
        'error' in response) {
        return Promise.reject(response.error);
    }
    return response;
});
const BLE_PACKET_SIZE_FALLBACK = 192;
const BLE_PACKET_SIZE_MAXIMUM = 244;
const BLE_WRITE_DELAY_MS = 5;
const PROTOCOL_PROBE_TIMEOUT_MS = 3000;
const PROTOCOL_V2_PROBE_TIMEOUT_MS = 5000;
class ElectronBleTransport {
    constructor() {
        this.name = 'ElectronBleTransport';
        this.configured = false;
        this.runPromise = null;
        this.runPromiseDeviceId = null;
        this.connectedDevices = new Set();
        this.acquiringDevices = new Set();
        this.deviceProtocol = new Map();
        this.deviceProtocolHints = new Map();
        this.deviceMtus = new Map();
        this.devicePacketCapacities = new Map();
        this.v1Buffers = new Map();
        this.v2Assemblers = new Map();
        this.v2FrameQueues = new Map();
        this.v2FramePromises = new Map();
        this.protocolV2Links = new transport.ProtocolV2LinkManager({
            getSchemas: () => {
                if (!this._messages || !this._messagesV2) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
                }
                return {
                    protocolV1: this._messages,
                    protocolV2: this._messagesV2,
                };
            },
            classifyError: () => 'link-fatal',
            onLinkInvalidated: (uuid, reason) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                (_a = this.v2Assemblers.get(uuid)) === null || _a === void 0 ? void 0 : _a.reset();
                this.rejectProtocolV2Frames(uuid, new Error(reason));
                (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug('[Electron BLE] Protocol V2 link invalidated:', uuid, reason);
                if (reason.startsWith('Protocol V2 link-fatal error:')) {
                    yield this.releaseNative(uuid, { forceNative: true });
                }
            }),
        });
        this.warnedMissingRelease = false;
        this.notificationCleanups = new Map();
        this.mtuCleanups = new Map();
        this.notificationTokens = new Map();
        this.nextNotificationToken = 1;
    }
    normalizeBluetoothError(error) {
        if (error && typeof error === 'object') {
            if (typeof error.errorCode === 'number') {
                return hdShared.ERRORS.TypedError(error.errorCode, typeof error.message === 'string' ? error.message : undefined, error.params);
            }
            if ('code' in error) {
                if (error.code === hdShared.HardwareErrorCode.BlePoweredOff) {
                    return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BlePoweredOff);
                }
                if (error.code === hdShared.HardwareErrorCode.BleUnsupported) {
                    return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleUnsupported);
                }
                if (error.code === hdShared.HardwareErrorCode.BlePermissionError) {
                    return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BlePermissionError);
                }
            }
            const errorMessage = error.message || String(error);
            const poweredOffMessage = hdShared.HardwareErrorCodeMessage[hdShared.HardwareErrorCode.BlePoweredOff];
            const unsupportedMessage = hdShared.HardwareErrorCodeMessage[hdShared.HardwareErrorCode.BleUnsupported];
            const permissionMessage = hdShared.HardwareErrorCodeMessage[hdShared.HardwareErrorCode.BlePermissionError];
            if (errorMessage.includes(poweredOffMessage) || errorMessage.includes('poweredOff')) {
                return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BlePoweredOff);
            }
            if (errorMessage.includes(unsupportedMessage) || errorMessage.includes('unsupported')) {
                return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleUnsupported);
            }
            if (errorMessage.includes(permissionMessage) || errorMessage.includes('unauthorized')) {
                return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BlePermissionError);
            }
        }
        return error;
    }
    handleBluetoothError(error) {
        throw this.normalizeBluetoothError(error);
    }
    cleanupDeviceState(deviceId) {
        this.protocolV2Links
            .invalidateLink(deviceId, 'Electron BLE device state cleaned')
            .catch(error => { var _a; return (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Electron BLE] link cleanup failed:', error); });
        this.connectedDevices.delete(deviceId);
        this.deviceProtocol.delete(deviceId);
        this.deviceMtus.delete(deviceId);
        this.devicePacketCapacities.delete(deviceId);
        this.v1Buffers.delete(deviceId);
        this.v2Assemblers.delete(deviceId);
        this.resetProtocolV2Frames(deviceId);
        this.notificationTokens.delete(deviceId);
        if (this.runPromise && this.runPromiseDeviceId === deviceId) {
            this.runPromise.reject(hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleDeviceDisconnected));
            this.runPromise = null;
            this.runPromiseDeviceId = null;
        }
        const notifyCleanup = this.notificationCleanups.get(deviceId);
        if (notifyCleanup) {
            notifyCleanup();
            this.notificationCleanups.delete(deviceId);
        }
        const mtuCleanup = this.mtuCleanups.get(deviceId);
        if (mtuCleanup) {
            mtuCleanup();
            this.mtuCleanups.delete(deviceId);
        }
    }
    init(logger, emitter) {
        var _a, _b;
        this.Log = logger;
        this.emitter = emitter;
        if (!((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle)) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, 'Noble BLE API is not available. Please ensure you are running in Electron with Noble support.');
        }
        this.subscribeHostDisconnects();
        (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug('[Electron BLE] Transport initialized');
    }
    subscribeHostDisconnects() {
        var _a, _b, _c;
        (_a = this.hostDisconnectCleanup) === null || _a === void 0 ? void 0 : _a.call(this);
        this.hostDisconnectCleanup = (_c = (_b = window.desktopApi) === null || _b === void 0 ? void 0 : _b.nobleBle) === null || _c === void 0 ? void 0 : _c.onDeviceDisconnected((disconnectedDevice) => {
            var _a, _b, _c;
            const uuid = disconnectedDevice === null || disconnectedDevice === void 0 ? void 0 : disconnectedDevice.id;
            if (!uuid)
                return;
            this.cleanupDeviceState(uuid);
            (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Electron BLE] Device link dropped:', uuid, (_b = disconnectedDevice.reason) !== null && _b !== void 0 ? _b : hdShared.EBleDisconnectReason.DeviceDisconnected);
            (_c = this.emitter) === null || _c === void 0 ? void 0 : _c.emit(transport.TRANSPORT_EVENT.DEVICE_DISCONNECT, {
                name: disconnectedDevice.name,
                id: uuid,
                connectId: uuid,
            });
        });
    }
    configure(signedData) {
        this._messages = parseConfigure(signedData);
        this.configured = true;
    }
    configureProtocolV2(signedData) {
        const configuration = typeof signedData === 'string' ? signedData : JSON.stringify(signedData);
        if (this.protocolV2SchemaConfiguration === configuration) {
            return;
        }
        const isReconfiguration = this.protocolV2SchemaConfiguration !== undefined;
        this._messagesV2 = parseConfigure(signedData);
        this.protocolV2SchemaConfiguration = configuration;
        if (isReconfiguration) {
            this.protocolV2Links
                .invalidateAllLinks('Protocol V2 schema reconfigured')
                .catch(error => { var _a; return (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Electron BLE] schema link cleanup failed:', error); });
        }
    }
    listen() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.enumerate();
        });
    }
    enumerate() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle)) {
                    throw new Error('Noble BLE API not available');
                }
                const devices = yield invokeNobleBle(window.desktopApi.nobleBle.enumerate());
                (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug(`[Electron BLE] enumerate found ${devices.length} device(s):`);
                for (const dev of devices) {
                    (_c = this.Log) === null || _c === void 0 ? void 0 : _c.debug(`[Electron BLE]   id="${dev.id}" name="${dev.name}"`);
                }
                return devices.map(device => toBleDescriptor(device));
            }
            catch (error) {
                (_d = this.Log) === null || _d === void 0 ? void 0 : _d.error('[Electron BLE] enumerate failed:', error);
                this.handleBluetoothError(error);
            }
        });
    }
    acquire(input) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            const { uuid, forceCleanRunPromise, expectedProtocol } = input;
            if (!uuid) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleRequiredUUID);
            }
            if (this.connectedDevices.has(uuid)) {
                yield this.release(uuid);
            }
            if (forceCleanRunPromise && this.runPromise) {
                const error = hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleForceCleanRunPromise);
                this.runPromise.reject(error);
                this.runPromise = null;
                this.runPromiseDeviceId = null;
            }
            this.acquiringDevices.add(uuid);
            try {
                if (!((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle)) {
                    throw new Error('Noble BLE API not available');
                }
                const device = yield invokeNobleBle(window.desktopApi.nobleBle.getDevice(uuid));
                if (!device) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, `Device ${uuid} not found`);
                }
                const protocolHint = expectedProtocol
                    ? undefined
                    : (_b = input.protocolHint) !== null && _b !== void 0 ? _b : this.deviceProtocolHints.get(uuid);
                if (protocolHint) {
                    this.deviceProtocolHints.set(uuid, protocolHint);
                }
                try {
                    yield invokeNobleBle(window.desktopApi.nobleBle.connect(uuid));
                    this.connectedDevices.add(uuid);
                }
                catch (error) {
                    this.handleBluetoothError(error);
                }
                const mtuCleanup = this.createMtuSubscription(uuid);
                if (mtuCleanup) {
                    this.mtuCleanups.set(uuid, mtuCleanup);
                }
                this.v1Buffers.set(uuid, { buffer: [], bufferLength: 0 });
                this.v2Assemblers.set(uuid, new transport.ProtocolV2FrameAssembler(transport.PROTOCOL_V2_BLE_FRAME_MAX_BYTES));
                try {
                    yield invokeNobleBle(window.desktopApi.nobleBle.subscribe(uuid));
                }
                catch (error) {
                    this.handleBluetoothError(error);
                }
                yield this.refreshBlePacketCapacity(uuid);
                const cleanup = this.createNotificationSubscription(uuid);
                this.notificationCleanups.set(uuid, cleanup);
                const protocolType = yield this.detectProtocol(uuid, expectedProtocol, protocolHint);
                if (protocolType === 'V2') {
                    (_c = this.Log) === null || _c === void 0 ? void 0 : _c.debug('[Electron BLE] Protocol V2 write configured', {
                        writeMode: 'withoutResponse',
                        negotiatedMtu: this.deviceMtus.get(uuid),
                        packetCapacity: (_d = this.devicePacketCapacities.get(uuid)) !== null && _d !== void 0 ? _d : BLE_PACKET_SIZE_FALLBACK,
                    });
                }
                return Object.assign(Object.assign({}, toBleDescriptor({ id: device.id, name: device.name }, protocolType)), { uuid });
            }
            catch (error) {
                (_e = this.Log) === null || _e === void 0 ? void 0 : _e.error('[Electron BLE] acquire failed:', error);
                try {
                    const nobleBle = (_f = window.desktopApi) === null || _f === void 0 ? void 0 : _f.nobleBle;
                    if (nobleBle) {
                        if (this.connectedDevices.has(uuid)) {
                            yield invokeNobleBle(nobleBle.unsubscribe(uuid)).catch(cleanupError => {
                                var _a;
                                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Electron BLE] acquire unsubscribe failed:', cleanupError);
                            });
                        }
                        yield invokeNobleBle(nobleBle.disconnect(uuid));
                    }
                }
                catch (cleanupError) {
                    (_g = this.Log) === null || _g === void 0 ? void 0 : _g.debug('[Electron BLE] acquire cleanup failed:', cleanupError);
                }
                this.cleanupDeviceState(uuid);
                this.handleBluetoothError(error);
            }
            finally {
                this.acquiringDevices.delete(uuid);
            }
        });
    }
    release(id, _onclose, keepSession) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.protocolV2Links.invalidateLink(id, 'Electron BLE transport released');
                yield this.releaseLogical(id, keepSession);
            }
            catch (error) {
                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.error('[Electron BLE] release failed:', error);
                this.cleanupDeviceState(id);
            }
        });
    }
    disconnect(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.releaseNative(id);
        });
    }
    releaseNative(id, options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const rendererOwnsLink = this.connectedDevices.has(id) || this.acquiringDevices.has(id);
            const shouldDisconnect = (options === null || options === void 0 ? void 0 : options.forceNative) === true || rendererOwnsLink;
            try {
                const nobleBle = (_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle;
                if (nobleBle && shouldDisconnect) {
                    if (this.connectedDevices.has(id)) {
                        yield invokeNobleBle(nobleBle.unsubscribe(id)).catch(error => {
                            var _a;
                            (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Electron BLE] release unsubscribe failed:', error);
                        });
                    }
                    yield invokeNobleBle(nobleBle.disconnect(id));
                }
                this.cleanupDeviceState(id);
            }
            catch (error) {
                (_b = this.Log) === null || _b === void 0 ? void 0 : _b.error('[Electron BLE] release failed:', error);
                this.cleanupDeviceState(id);
            }
        });
    }
    releaseLogical(id, keepSession) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.connectedDevices.has(id))
                    return;
                this.cleanupDeviceState(id);
                const release = (_b = (_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle) === null || _b === void 0 ? void 0 : _b.release;
                if (!release) {
                    if (!this.warnedMissingRelease) {
                        this.warnedMissingRelease = true;
                        (_c = this.Log) === null || _c === void 0 ? void 0 : _c.error('[Electron BLE] desktopApi.nobleBle.release is missing from the preload bridge; ' +
                            'keep-alive idle countdown will never start — map NOBLE_BLE_RELEASE in the desktop preload');
                    }
                    return;
                }
                yield invokeNobleBle(release(id, keepSession));
            }
            catch (error) {
                (_d = this.Log) === null || _d === void 0 ? void 0 : _d.error('[Electron BLE] logical release failed:', error);
                this.cleanupDeviceState(id);
            }
        });
    }
    createProtocolMismatchError(expected) {
        return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, `Device protocol mismatch: expected ${expected}, but device did not respond to expected protocol`);
    }
    createProtocolDetectionError() {
        return hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleTimeoutError, 'Unable to detect BLE protocol: device did not respond to Protocol V1 GetFeatures or Protocol V2 Ping');
    }
    clearProbeProtocol(uuid, protocol) {
        if (this.deviceProtocol.get(uuid) === protocol) {
            this.deviceProtocol.delete(uuid);
        }
    }
    detectProtocol(uuid, expectedProtocol, protocolHint) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            if (expectedProtocol === 'V1') {
                this.deviceProtocol.set(uuid, 'V1');
                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug(`[Electron BLE] detectProtocol: uuid=${uuid} -> V1 (expected, no probe)`);
                return 'V1';
            }
            if (expectedProtocol === 'V2') {
                if (yield this.probeProtocolV2(uuid, expectedProtocol)) {
                    this.deviceProtocol.set(uuid, 'V2');
                    (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug(`[Electron BLE] detectProtocol: uuid=${uuid} -> V2 (expected)`);
                    return 'V2';
                }
                throw this.createProtocolMismatchError(expectedProtocol);
            }
            const probeOrder = protocolHint === 'V2' || this.deviceProtocol.get(uuid) === 'V2' ? ['V2', 'V1'] : ['V1', 'V2'];
            for (let i = 0; i < probeOrder.length; i += 1) {
                const protocol = probeOrder[i];
                if (i > 0) {
                    yield this.resetProbeStateAfterProtocolProbe(uuid, probeOrder[i - 1]);
                }
                const detected = protocol === 'V1' ? yield this.probeProtocolV1(uuid) : yield this.probeProtocolV2(uuid);
                if (detected) {
                    this.deviceProtocol.set(uuid, protocol);
                    (_c = this.Log) === null || _c === void 0 ? void 0 : _c.debug(`[Electron BLE] detectProtocol: uuid=${uuid} -> ${protocol}`);
                    return protocol;
                }
            }
            this.deviceProtocol.delete(uuid);
            throw this.createProtocolDetectionError();
        });
    }
    createNotificationSubscription(uuid) {
        var _a;
        if (!((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle)) {
            throw new Error('Noble BLE API not available');
        }
        const notificationToken = this.nextNotificationToken;
        this.nextNotificationToken += 1;
        this.notificationTokens.set(uuid, notificationToken);
        return window.desktopApi.nobleBle.onNotification((deviceId, data) => {
            if (deviceId === uuid && this.notificationTokens.get(uuid) === notificationToken) {
                this.handleNotification(uuid, data);
            }
        });
    }
    resetProbeStateAfterProtocolProbe(uuid, protocol) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.protocolV2Links.invalidateLink(uuid, `Reset notify state after Protocol ${protocol} probe`);
            this.v1Buffers.set(uuid, { buffer: [], bufferLength: 0 });
            (_a = this.v2Assemblers.get(uuid)) === null || _a === void 0 ? void 0 : _a.reset();
            this.resetProtocolV2Frames(uuid);
            if (this.runPromise && this.runPromiseDeviceId === uuid) {
                const error = hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleForceCleanRunPromise);
                this.runPromise.reject(error);
                this.runPromise = null;
                this.runPromiseDeviceId = null;
            }
            if (!this.notificationCleanups.has(uuid)) {
                const cleanup = this.createNotificationSubscription(uuid);
                this.notificationCleanups.set(uuid, cleanup);
            }
        });
    }
    probeProtocolV1(uuid) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._messages) {
                return false;
            }
            try {
                this.deviceProtocol.set(uuid, 'V1');
                yield this.callProtocolV1(uuid, 'GetFeatures', {}, { timeoutMs: PROTOCOL_PROBE_TIMEOUT_MS });
                return true;
            }
            catch (error) {
                this.clearProbeProtocol(uuid, 'V1');
                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Electron BLE] Protocol V1 GetFeatures probe failed:', error);
                if (transport.isProtocolV2LinkDisabledError(error)) {
                    throw error;
                }
                return false;
            }
        });
    }
    probeProtocolV2(uuid, expectedProtocol) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._messages || !this._messagesV2) {
                return false;
            }
            this.deviceProtocol.set(uuid, 'V2');
            (_a = this.v2Assemblers.get(uuid)) === null || _a === void 0 ? void 0 : _a.reset();
            const detected = yield transport.probeProtocolV2({
                call: (name, data, options) => this.callProtocolV2(uuid, name, data, options),
                timeoutMs: PROTOCOL_V2_PROBE_TIMEOUT_MS,
                logger: this.Log,
                logPrefix: 'ProtocolV2 BLE',
                onProbeFailed: () => {
                    var _a;
                    (_a = this.v2Assemblers.get(uuid)) === null || _a === void 0 ? void 0 : _a.reset();
                    this.resetProtocolV2Frames(uuid);
                },
                shouldRethrow: error => expectedProtocol === 'V2' ||
                    hdShared.isBleStaleBondHardwareError(error) ||
                    transport.isProtocolV2LinkDisabledError(error),
            });
            if (!detected) {
                this.clearProbeProtocol(uuid, 'V2');
            }
            return detected;
        });
    }
    writeOnce(uuid, hexData) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const nobleBle = (_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle;
            if (!nobleBle) {
                throw new Error('Noble BLE API not available');
            }
            try {
                yield invokeNobleBle(nobleBle.write(uuid, hexData, { pacingDelayMs: 0 }));
            }
            catch (error) {
                this.handleBluetoothError(error);
            }
        });
    }
    refreshBlePacketCapacity(uuid) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const nobleBle = (_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle;
            const device = nobleBle ? yield invokeNobleBle(nobleBle.getDevice(uuid)) : undefined;
            this.updateBlePacketCapacity(uuid, device === null || device === void 0 ? void 0 : device.mtu);
        });
    }
    updateBlePacketCapacity(uuid, mtu) {
        const packetCapacity = resolveBlePacketCapacity(mtu, BLE_PACKET_SIZE_MAXIMUM, BLE_PACKET_SIZE_FALLBACK);
        if (typeof mtu === 'number') {
            this.deviceMtus.set(uuid, mtu);
        }
        else {
            this.deviceMtus.delete(uuid);
        }
        this.devicePacketCapacities.set(uuid, packetCapacity);
    }
    createMtuSubscription(uuid) {
        var _a, _b;
        const onMtuChanged = (_b = (_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle) === null || _b === void 0 ? void 0 : _b.onMtuChanged;
        if (!onMtuChanged)
            return undefined;
        return onMtuChanged(device => {
            if (device.id === uuid) {
                this.updateBlePacketCapacity(uuid, device.mtu);
            }
        });
    }
    writeProtocolV2Frame(uuid, frame, context, assertCurrentGeneration) {
        var _a;
        const packetCapacity = (_a = this.devicePacketCapacities.get(uuid)) !== null && _a !== void 0 ? _a : BLE_PACKET_SIZE_FALLBACK;
        const shouldPace = !context.highThroughput;
        return transport.writeProtocolV2BleFrame({
            frame,
            packetCapacity,
            assertActive: assertCurrentGeneration,
            signal: context.signal,
            abortMessage: `Protocol V2 BLE write aborted for ${context.messageName}`,
            initialDelayMs: shouldPace && frame.length <= packetCapacity ? BLE_WRITE_DELAY_MS : 0,
            burstSize: shouldPace ? 1 : undefined,
            burstPauseMs: shouldPace ? BLE_WRITE_DELAY_MS : 0,
            writePacket: packet => this.writeOnce(uuid, transport.bytesToHex(packet)),
        });
    }
    handleNotification(deviceId, hexData) {
        var _a, _b;
        if (hexData === 'PAIRING_REJECTED') {
            (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Electron BLE] Pairing rejection detected for device:', deviceId);
            const error = hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleDeviceBondedCanceled);
            if (this.deviceProtocol.get(deviceId) === 'V2') {
                this.rejectProtocolV2Frames(deviceId, error);
            }
            else if (this.runPromise && this.runPromiseDeviceId === deviceId) {
                this.runPromise.reject(error);
            }
            return;
        }
        const protocol = this.deviceProtocol.get(deviceId);
        if (!protocol) {
            (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug('[Electron BLE] Ignore notification before protocol detection:', deviceId);
            return;
        }
        if (protocol === 'V2') {
            this.handleProtocolV2Notification(deviceId, hexData);
            return;
        }
        const linkDisabledError = this.readProtocolV2LinkDisabledFailure(deviceId, hexData);
        if (linkDisabledError) {
            if (this.runPromise && this.runPromiseDeviceId === deviceId) {
                this.runPromise.reject(linkDisabledError);
            }
            return;
        }
        this.handleProtocolV1Notification(deviceId, hexData);
    }
    readProtocolV2LinkDisabledFailure(deviceId, hexData) {
        if (!this._messages || !this._messagesV2)
            return undefined;
        const assembler = this.v2Assemblers.get(deviceId);
        if (!assembler)
            return undefined;
        return transport.detectProtocolV2LinkDisabledError({
            schemas: { protocolV1: this._messages, protocolV2: this._messagesV2 },
            assembler,
            bytes: transport.hexToBytes(hexData),
        });
    }
    handleProtocolV2Notification(deviceId, hexData) {
        var _a;
        try {
            const bytes = transport.hexToBytes(hexData);
            if (bytes.length === 0)
                return;
            const assembler = this.v2Assemblers.get(deviceId);
            if (!assembler)
                return;
            for (const frameData of assembler.drain(bytes)) {
                this.resolveProtocolV2Frame(deviceId, frameData);
            }
        }
        catch (error) {
            (_a = this.Log) === null || _a === void 0 ? void 0 : _a.error('[Electron BLE] Protocol V2 notification error:', error);
            const notifyError = hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleWriteCharacteristicError);
            this.rejectProtocolV2Frames(deviceId, notifyError);
        }
    }
    getProtocolV2FrameQueue(uuid) {
        let queue = this.v2FrameQueues.get(uuid);
        if (!queue) {
            queue = [];
            this.v2FrameQueues.set(uuid, queue);
        }
        return queue;
    }
    resolveProtocolV2Frame(uuid, frame) {
        const framePromise = this.v2FramePromises.get(uuid);
        if (framePromise) {
            framePromise.resolve(frame);
            this.v2FramePromises.delete(uuid);
            return;
        }
        this.getProtocolV2FrameQueue(uuid).push(frame);
    }
    resetProtocolV2Frames(uuid) {
        this.rejectProtocolV2Frames(uuid, new Error(`Protocol V2 frame state reset for ${uuid}`));
    }
    rejectProtocolV2Frames(uuid, error) {
        this.v2FrameQueues.delete(uuid);
        const framePromise = this.v2FramePromises.get(uuid);
        if (framePromise) {
            this.v2FramePromises.delete(uuid);
            framePromise.reject(error);
        }
    }
    readProtocolV2Frame(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const queuedFrame = this.getProtocolV2FrameQueue(uuid).shift();
            if (queuedFrame) {
                return queuedFrame;
            }
            const framePromise = hdShared.createDeferred();
            this.v2FramePromises.set(uuid, framePromise);
            try {
                return yield framePromise.promise;
            }
            finally {
                if (this.v2FramePromises.get(uuid) === framePromise) {
                    this.v2FramePromises.delete(uuid);
                }
            }
        });
    }
    handleProtocolV1Notification(deviceId, hexData) {
        var _a;
        const result = this.processProtocolV1Notification(deviceId, hexData);
        if (result.error) {
            (_a = this.Log) === null || _a === void 0 ? void 0 : _a.error('[Electron BLE] Protocol V1 packet processing error:', result.error);
            if (this.runPromise && this.runPromiseDeviceId === deviceId) {
                this.runPromise.reject(hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleWriteCharacteristicError));
            }
            return;
        }
        if (result.isComplete &&
            result.completePacket &&
            this.runPromise &&
            this.runPromiseDeviceId === deviceId) {
            this.runPromise.resolve(result.completePacket);
        }
    }
    call(uuid, name, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._messages) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            if (!this.connectedDevices.has(uuid)) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotFound, `Device ${uuid} not connected`);
            }
            const protocol = this.deviceProtocol.get(uuid);
            if (!protocol) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, `Device protocol has not been detected for ${uuid}`);
            }
            if (protocol === 'V2') {
                return this.callProtocolV2(uuid, name, data, options);
            }
            return this.callProtocolV1(uuid, name, data, options);
        });
    }
    post(uuid, name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.deviceProtocol.get(uuid) === 'V2') {
                yield this.protocolV2Links.sendFlowControl(uuid, () => this.createProtocolV2Adapter(uuid), name, data);
                return;
            }
            yield this.callProtocolV1(uuid, name, data);
        });
    }
    callProtocolV1(uuid, name, data, options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._messages) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            const forceRun = name === 'Initialize' || name === 'Cancel';
            if (this.runPromise && !forceRun) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportCallInProgress);
            }
            const runPromise = hdShared.createDeferred();
            runPromise.promise.catch(() => undefined);
            this.runPromise = runPromise;
            this.runPromiseDeviceId = uuid;
            const messages = this._messages;
            const buffers = ProtocolV1.encodeTransportPackets(messages, name, data);
            let timeout;
            try {
                if (!((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle)) {
                    throw new Error('Noble BLE write API not available');
                }
                for (let i = 0; i < buffers.length; i++) {
                    const buffer = buffers[i];
                    if (!buffer || typeof buffer.toString !== 'function') {
                        throw new Error(`Buffer ${i + 1} is invalid`);
                    }
                    const hexString = buffer.toString('hex');
                    if (hexString.length === 0) {
                        throw new Error(`Buffer ${i + 1} is empty`);
                    }
                    yield invokeNobleBle(window.desktopApi.nobleBle.write(uuid, hexString));
                }
                const response = yield Promise.race([
                    runPromise.promise,
                    new Promise((_, reject) => {
                        if (options === null || options === void 0 ? void 0 : options.timeoutMs) {
                            timeout = setTimeout(() => {
                                const error = hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleTimeoutError, `BLE response timeout after ${options.timeoutMs}ms for ${name}`);
                                runPromise.reject(error);
                                reject(error);
                            }, options.timeoutMs);
                        }
                    }),
                ]);
                if (typeof response !== 'string') {
                    throw new Error('Returning data is not string.');
                }
                const jsonData = ProtocolV1.decodeMessage(messages, response);
                return check.call(jsonData);
            }
            catch (e) {
                (_b = this.Log) === null || _b === void 0 ? void 0 : _b.error('[Electron BLE] Protocol V1 call error:', e);
                const isProbeTimeout = name === 'GetFeatures' && (options === null || options === void 0 ? void 0 : options.timeoutMs) === PROTOCOL_PROBE_TIMEOUT_MS;
                if ((e === null || e === void 0 ? void 0 : e.errorCode) === hdShared.HardwareErrorCode.BleTimeoutError) {
                    this.v1Buffers.set(uuid, { buffer: [], bufferLength: 0 });
                    const notifyCleanup = this.notificationCleanups.get(uuid);
                    notifyCleanup === null || notifyCleanup === void 0 ? void 0 : notifyCleanup();
                    this.notificationCleanups.delete(uuid);
                    this.notificationTokens.delete(uuid);
                    if (!isProbeTimeout) {
                        yield this.releaseNative(uuid, { forceNative: true });
                    }
                }
                throw this.normalizeBluetoothError(e);
            }
            finally {
                if (timeout)
                    clearTimeout(timeout);
                if (this.runPromise === runPromise) {
                    this.runPromise = null;
                    this.runPromiseDeviceId = null;
                }
            }
        });
    }
    callProtocolV2(uuid, name, data, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._messages || !this._messagesV2) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            const callOptions = options;
            try {
                return yield this.protocolV2Links.call(uuid, () => this.createProtocolV2Adapter(uuid), name, data, callOptions);
            }
            catch (e) {
                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.error('[Electron BLE] Protocol V2 call error:', e);
                throw e;
            }
        });
    }
    createProtocolV2Adapter(uuid) {
        var _a;
        const generation = (_a = this.notificationTokens.get(uuid)) !== null && _a !== void 0 ? _a : 0;
        const assertCurrentGeneration = () => {
            if (this.notificationTokens.get(uuid) !== generation) {
                throw new Error(`Protocol V2 notification generation changed for ${uuid}`);
            }
        };
        return {
            router: transport.PROTOCOL_V2_CHANNEL_BLE_UART,
            maxFrameBytes: transport.PROTOCOL_V2_BLE_FRAME_MAX_BYTES,
            generation,
            prepareCall: () => {
                var _a;
                assertCurrentGeneration();
                (_a = this.v2Assemblers.get(uuid)) === null || _a === void 0 ? void 0 : _a.reset();
                this.resetProtocolV2Frames(uuid);
            },
            writeFrame: (frame, context) => this.writeProtocolV2Frame(uuid, frame, context, assertCurrentGeneration),
            readFrame: () => __awaiter(this, void 0, void 0, function* () {
                assertCurrentGeneration();
                const rxFrame = yield this.readProtocolV2Frame(uuid);
                if (!(rxFrame instanceof Uint8Array)) {
                    throw new Error('Response is not Uint8Array');
                }
                return rxFrame;
            }),
            reset: (reason) => {
                var _a;
                (_a = this.v2Assemblers.get(uuid)) === null || _a === void 0 ? void 0 : _a.reset();
                this.rejectProtocolV2Frames(uuid, new Error(reason));
            },
            logger: this.Log,
            logPrefix: 'ProtocolV2 BLE',
            createTimeoutError: (messageName, timeout) => hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleTimeoutError, `BLE response timeout after ${timeout}ms for ${messageName}`),
        };
    }
    processProtocolV1Notification(deviceId, hexData) {
        var _a;
        try {
            if (typeof hexData !== 'string') {
                return { isComplete: false, error: 'Invalid hexData type' };
            }
            const data = transport.hexToBytes(hexData);
            if (data.length === 0) {
                return { isComplete: false, error: 'Empty or invalid hex data' };
            }
            const bufferState = this.v1Buffers.get(deviceId);
            if (!bufferState) {
                return { isComplete: false, error: 'No buffer state for device' };
            }
            if (hdShared.isHeaderChunk(data)) {
                const dataView = new DataView(data.buffer);
                bufferState.bufferLength = dataView.getInt32(5, false);
                bufferState.buffer = [...data.subarray(3)];
            }
            else {
                if (bufferState.buffer.length === 0) {
                    (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Electron BLE] Orphan continuation chunk discarded');
                    return { isComplete: false };
                }
                bufferState.buffer = bufferState.buffer.concat([...data]);
            }
            if (bufferState.buffer.length - transport.PROTOCOL_V1_MESSAGE_HEADER_SIZE >= bufferState.bufferLength) {
                const completeBuffer = new Uint8Array(bufferState.buffer);
                bufferState.bufferLength = 0;
                bufferState.buffer = [];
                return { isComplete: true, completePacket: transport.bytesToHex(completeBuffer) };
            }
            return { isComplete: false };
        }
        catch (error) {
            return { isComplete: false, error: `Packet processing error: ${error}` };
        }
    }
    getProtocolType(path) {
        return this.deviceProtocol.get(path);
    }
}

exports.ElectronBleTransport = ElectronBleTransport;
exports.WebUsbTransport = WebUsbTransport;
